import { useState } from "react";
import { ArrowRightLeft, CalendarDays, Plus, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip } from "@/components/ui/misc";
import { DatePicker } from "@/components/ui/date-picker";
import { useHierarchy } from "@/data/hooks";
import { useTaskActions } from "@/data/actions";
import { modKey } from "@/lib/utils";
import { openQuickAdd, ui, useUi } from "@/features/ui-state";
import { taskRegistry } from "@/features/list/registry";
import { MoveDialog } from "@/features/destination/MoveDialog";

/** Things-style bottom toolbar: New task · When · Move · Search. When/Move act on the selected task. */
export function Toolbar() {
  const h = useHierarchy();
  const a = useTaskActions();
  const sel = useUi((s) => s.selectedTaskId);
  const task = sel ? taskRegistry.get(sel) : undefined;
  const [moveOpen, setMoveOpen] = useState(false);
  return (
    <div role="toolbar" aria-label="Task actions" className="flex items-center gap-0.5">
      <Tooltip content="New task" shortcut={`${modKey}N`}>
        <Button size="icon" variant="quiet" aria-label="New task" onClick={() => openQuickAdd()}>
          <Plus />
        </Button>
      </Tooltip>
      <DatePicker value={task?.plannedDate ?? null} today={h.today} onChange={(d) => task && void a.setWhen(task, d)} clearLabel="No date" align="center">
        <Button size="icon" variant="quiet" aria-label={task ? `When for ${task.readableId}` : "When (select a task first)"} disabled={!task}>
          <CalendarDays />
        </Button>
      </DatePicker>
      <Tooltip content="Move" shortcut="M">
        <Button size="icon" variant="quiet" aria-label="Move selected task" disabled={!task} onClick={() => setMoveOpen(true)}>
          <ArrowRightLeft />
        </Button>
      </Tooltip>
      <Tooltip content="Search" shortcut={`${modKey}K`}>
        <Button size="icon" variant="quiet" aria-label="Search" onClick={() => ui.set({ paletteOpen: true })}>
          <Search />
        </Button>
      </Tooltip>
      {task && <MoveDialog task={task} open={moveOpen} onOpenChange={setMoveOpen} />}
    </div>
  );
}
